module.exports = __webpack_public_path__ + "img/experience-image.d5ebca73.svg";